import { useState } from 'react';

import useFetch from 'hooks/useFetch';
import useRetry from 'hooks/useRetry';

import useTranslation from './hooks/useTranslation';

import { JSON_HEADERS, MIX_RECIPES_API, MIX_RECIPE_API_HOST } from './constants';
import normalizeMixRecipe from './normalizeMixRecipe';
import type { FetchMixRecipe, RawMixRecipe } from './types';

const useMixRecipe = () => {
    const [isLoading, setIsLoading] = useState(false);
    const { authenticatedGet } = useFetch({
        apiHost: MIX_RECIPE_API_HOST,
        headers: JSON_HEADERS
    });
    const { withRetry } = useRetry();
    const { CONNECTION_ERROR } = useTranslation();

    const fetchMixRecipe: FetchMixRecipe = async ({ id }) => {
        try {
            setIsLoading(true);

            const raw = await withRetry(
                () => authenticatedGet<RawMixRecipe>(`${MIX_RECIPES_API}/${id}`),
                CONNECTION_ERROR,
                () => fetchMixRecipe({ id })
            );

            return normalizeMixRecipe(raw);
        } finally {
            setIsLoading(false);
        }
    };

    return {
        fetchMixRecipe,
        isLoading
    };
};

export default useMixRecipe;
